import { OptionInput } from "@brexhq/component-library";
import * as React from "react";
import { FormState } from "react-hook-form";

import {
  FormSubmissionState,
  fundingSourceOptions,
  Step,
  FieldValues,
} from "@brexhq/next/src/components/modules/FormMultistep/types";
import { TitleS } from "@brexhq/shared/components/Typography/Components";

import { Actions, ErrorBox, titleMargin } from "../FormMultistep.elements";
import { DynamicLeadFormController } from "../dynamicLeadFormController";

import { dynamicFirstStep } from "./dynamicFirstStep";

const DynamicSecondStepView: React.FC<{ ctrl: DynamicLeadFormController }> = ({
  ctrl,
}) => {
  const { fields, formSubmissionState, next, customSubmitButtonLabel } = ctrl;
  return (
    <>
      <div>
        <TitleS margin={titleMargin}>
          {
            "Based on your answers, we’ll need you to answer a couple more questions."
          }
        </TitleS>
      </div>
      <OptionInput {...fields.isEcomm} size="large" />
      <OptionInput
        {...fields.fundingSource}
        size="large"
        options={fundingSourceOptions}
      />
      {formSubmissionState === FormSubmissionState.SUBMITTED_AND_FAILED && (
        <ErrorBox onSubmit={next} />
      )}
      <Actions ctrl={ctrl} label={customSubmitButtonLabel} />
    </>
  );
};

const isValid = (formState: FormState<FieldValues>) => {
  const { dirtyFields, errors } = formState;
  const noErrors = [errors.fundingSource, errors.isEcomm].every(
    (error) => error === undefined,
  );
  const allDirty = [dirtyFields.fundingSource, dirtyFields.isEcomm].every(
    Boolean,
  );

  return noErrors && allDirty;
};

export const dynamicSecondStep: Step = {
  id: "Dynamic second step",
  isValid,
  view: DynamicSecondStepView,
  next: async ({ finishWithUpdate }) => {
    return await finishWithUpdate();
  },
  back: (setStep) => setStep(dynamicFirstStep),
  hasPrevStep: () => true,
};
